<template>
<div>
    <v-card
        v-for="(domain, index) in profile.owned_domains"
        :key="index"
        style="margin-bottom: 7px"
    >
        <v-row>
            <v-col>
                <div class="domain_label">
                    {{domain.domain}}
                </div>
            </v-col>
            <v-col class="flex-grow-0">
                <div class="btn_container">
                    <v-btn
                        v-if="can_write"
                        v-on:click="deleteDomain(domain)"
                    >
                        Delete
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-card>

    <m-icon-bar
        v-on:add="showAddDomainDialog"
        v-show="can_write"
    />

    <m-settings-organization-add-domain
        ref="dialog-add-domain"
        v-on:domain-added="domainAdded"
    />
</div>
</template>

<!--
"owned_domains\" : [ {\n" + 
			"    \"organization_id\" : \"d0a00313-4d12-4d05-9fad-5203575674e6\",\n" + 
			"    \"ownership_id\" : \"ad8a690d-19e9-46d6-a7ae-dbc16ced23fd\",\n" + 
			"    \"domain\" : \"testchirp.com\"\n" + 
-->

<script>
const _ = require('lodash');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: 
    {
        deleteDomain(domain) {
            if ( !confirm('Remove domain name '+domain.domain+' from you account?') )
                return;

            this.$emit('delete-domain',domain);
        },

        showAddDomainDialog()
        {
            this.$refs['dialog-add-domain'].showDialog(this.profile.actor_permissions.is_system_admin, this.profile.organization_id);
        },

        domainAdded()
        {
            this.$emit('domain-added');
        }
    },

    mounted () {
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        }
    },
}
</script>

<style lang="scss" scoped>
.domain_label
{
    font-size: 20px; 
    font-weight: 500;
    color: rgba(0,0,0,0.87);
    padding-left: 15px;
}
.btn_container
{
    padding-right: 15px;
}
</style>